module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd",
    style: ({
      'min-height': _vm.winW <= 1024 ? _vm.winH + 'px' : 0
    }),
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 0),
      expression: "step == 0"
    }],
    staticClass: "state"
  }, [_c('h4', {
    staticClass: "component_heading"
  }, [_vm._v(_vm._s(_vm.$t('login.heading')))]), _vm._v(" "), _c('p', {
    staticClass: "top_p"
  }, [_vm._v(_vm._s(_vm.$t('login.provide_phone')))]), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "input_hint"
  }, [_vm._v(_vm._s(_vm.$t('login.phone')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "tel_prefix"
    }
  }, [_vm._v("+380")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.phone),
      expression: "loginData.phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ### ####'),
      expression: "'(##) ### ####'"
    }],
    attrs: {
      "type": "tel",
      "id": "tel",
      "autocomplete": "off",
      "placeholder": "(00) XXX XXXX",
      "value": "38"
    },
    domProps: {
      "value": (_vm.loginData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      'active': _vm.phoneValid
    },
    on: {
      "click": _vm.requestSMS
    }
  }, [_vm._v(_vm._s(_vm.$t('login.next')))]), _vm._v(" "), _c('div', {
    staticClass: "errors"
  }, [(_vm.tooManySmsRequests) ? _c('p', {
    staticClass: "status error"
  }, [_vm._v(_vm._s(_vm.$t('login.too_many_requests')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "state"
  }, [_c('h4', {
    staticClass: "component_heading"
  }, [_vm._v(_vm._s(_vm.$t('login.heading')))]), _vm._v(" "), _c('p', {
    staticClass: "back",
    on: {
      "click": _vm.backToPhone
    }
  }, [_vm._v("<< " + _vm._s(_vm.$t('login.back')))]), _vm._v(" "), _c('p', {
    staticClass: "top_p"
  }, [_vm._v(_vm._s(_vm.$t('login.to_phone')) + "\n      "), _c('b', [_vm._v("+380 " + _vm._s(_vm.loginData.phone))]), _vm._v(" " + _vm._s(_vm.$t('login.sent_sms')))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_c('p', {
    staticClass: "input_hint"
  }, [_vm._v(_vm._s(_vm.$t('login.code_from_sms')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.pass),
      expression: "loginData.pass"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('######'),
      expression: "'######'"
    }],
    ref: "codeInput",
    attrs: {
      "type": "number",
      "id": "code",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.loginData.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "pass", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.codeVerifyErr) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.$t('login.wrong_code')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      'active': _vm.passValid
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v(_vm._s(_vm.$t('login.enter')))]), _vm._v(" "), (_vm.smsStatus.status == 1) ? _c('p', {
    staticClass: "status waiting"
  }, [_vm._v(_vm._s(_vm.$t('login.sms_sent_waiting')))]) : _vm._e(), _vm._v(" "), (_vm.smsStatus.status == 2) ? _c('p', {
    staticClass: "status success"
  }, [_vm._v(_vm._s(_vm.$t('login.code_delivered')) + " "), (_vm.smsStatus.hyber_status == 23022) ? _c('span', [_vm._v(_vm._s(_vm.$t('login.in_push')))]) : _vm._e(), (_vm.smsStatus.hyber_status == 23011) ? _c('span', [_vm._v(_vm._s(_vm.$t('login.in_sms')))]) : _vm._e(), (_vm.smsStatus.hyber_status == 23033) ? _c('span', [_vm._v(_vm._s(_vm.$t('login.in_viber')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.smsStatus.status == 3) ? _c('div', {
    staticClass: "errors"
  }, [(_vm.resetByBrowserTimeout) ? _c('p', {
    staticClass: "status error"
  }, [_vm._v(_vm._s(_vm.$t('login.delivery_service_down')))]) : _vm._e(), _vm._v(" "), (_vm.smsStatus.substatus == 35) ? _c('p', {
    staticClass: "status error"
  }, [_vm._v(_vm._s(_vm.$t('login.mes_expired')))]) : _vm._e(), _vm._v(" "), (_vm.smsStatus.substatus == 37) ? _c('p', {
    staticClass: "status error"
  }, [_vm._v(_vm._s(_vm.$t('login.cell_problems')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button active",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.$t('login.resend_sms')))])]) : _vm._e(), _vm._v(" "), (_vm.resetByBrowserTimeout) ? _c('div', {
    staticClass: "button active",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.$t('login.resend_sms')))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8fc585","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/fb-login.vue
// module id = 293
// module chunks = 1